import React from "react";
import { useParams } from "react-router-dom";
import { products } from "../products";
import CookieConsentPopup from "./CookieConsentPopup";
import ProductVisual from "./ProductVisual";

export default function ProductPage() {
  const { slug } = useParams();
  const product = products.find((p) => p.slug === slug);

  if (!product) {
    // Produto não encontrado
    return <div style={{ padding: 32 }}>Produto não encontrado.</div>;
  }

  return (
    <div style={{ minHeight: "100vh", width: "100vw", background: "#f4f4f4" }}>
      {/* Container do produto */}
      <div
        style={{
          margin: "0",
          padding: "0",
          display: "flex",
          flexDirection: "column",
          alignItems: "stretch",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100vh",
          }}
        >
          <ProductVisual
            desktopPageImageUrl={product.desktopPageImageUrl}
            mobilePageImageUrl={product.mobilePageImageUrl}
          />
        </div>
      </div>
      <CookieConsentPopup
        affiliateUrl={product.affiliateUrl}
        cookiesMessage={product.cookiesMessage}
      />
    </div>
  );
}
